module.exports = __webpack_public_path__ + "static/img/milena-biga.ed749279.jpg";